var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_359_2480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06 17.2L17.2 12L9.06 6.80001V17.2ZM12 24C10.3533 24 8.80001 23.685 7.34001 23.055C5.88001 22.425 4.60667 21.5667 3.51999 20.48C2.43333 19.3933 1.575 18.12 0.945 16.66C0.315 15.2 0 13.6467 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43333 4.59 3.51999 3.51C4.60667 2.43 5.88001 1.575 7.34001 0.945C8.80001 0.315 10.3533 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.6467 23.685 15.2 23.055 16.66C22.425 18.12 21.57 19.3933 20.49 20.48C19.41 21.5667 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24Z",
    fill: "black",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_359_2480",
    x: -2,
    y: -2,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_359_2480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_359_2480",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTask);
export default __webpack_public_path__ + "static/media/play_task.306186969dd47ae99bffce3a6f6b7dac.svg";
export { ForwardRef as ReactComponent };